import {AfterViewInit, Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {environment} from "@biletix/env";
import {LocaleSelectorComponent} from "@biletix/core/common/locale-selector.component";
import {TranslateService} from "@ngx-translate/core";
import {I18nService} from "@biletix/core/services/i18n.service";
import {ActivatedRoute} from "@angular/router";
import {RegionService} from "@biletix/core/services/region.service";
import {RouteParameter} from "@biletix/core/common/constants/route-parameter.const";
import {EventGroup} from "@biletix/core/models/event/event-group.model";
import {EventGroupPageStateService} from "@biletix/features/event-group/services/event-group-page-state.service";
import {WINDOW} from "@biletix/core/common";
import {Title} from '@angular/platform-browser';
import {Clipboard} from "@angular/cdk/clipboard";
import {ShareButtonsConfig} from "@biletix/shared/components/share-button/share-button.component";
import {ImageUrlManager} from "@biletix/core/common/helper/image-url-manager";
import {ImageProcessing} from "@biletix/core/common/utils/image-processing";
import {RouterService} from "@biletix/core/services/router.service";
// import { GoogleTagManagerService } from 'angular-google-tag-manager';
import {Locale, Region} from "@biletix/core/common"
import { LocalizedDatePipe } from '@biletix/shared/pipes/localized-date.pipe';
import { ApiService } from '@biletix/core/services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { EventService } from '@biletix/core/services/event.service';
import { EventGroupListItem } from '@biletix/core/models/event/event-group-list-item.model';
import { APP_BASE_HREF, DatePipe, isPlatformBrowser } from '@angular/common';
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";
import { SeoService } from '@biletix/core/services/seo.service';
import { CanonicalService } from '@biletix/core/services/canonical.service';
import { SeoPagePath, SeoUrlService } from '@biletix/core/services/seo-url.service';
import {GPT_AD_SLOT_IDS, GPT_SPECIAL_EVENT_GROUP_ID, GptAdService} from '@biletix/core/services/gpt-ad.service';
import {StructuredDataService} from '@biletix/core/services/structured-data.service';
import {
    SCHEMA_DATE_FORMAT,
    SCHEMA_TIMEZONE,
    buildEventItemList,
    schemaEventType,
} from '@biletix/core/common/utils/structured-data.util';
import {resolveListItemPrice} from '@biletix/core/common/utils/ga4-ecommerce.util';

@Component({
    standalone: false,
    selector: 'btx-event',
    templateUrl: './event-group.component.html',
    styleUrls: ['./event-group.component.scss']
})
export class EventGroupComponent extends LocaleSelectorComponent implements OnInit, AfterViewInit {

    /** Şablondaki koşullu slot seçimiyle aynı kimlik (bkz. event-group.component.html). */
    readonly specialEventGroupId = GPT_SPECIAL_EVENT_GROUP_ID;

    /** JSON-LD script'inin id'si; aynı id ile yazmak bloğu çoğaltmaz (bkz. StructuredDataService). */
    private static readonly SCHEMA_ELEMENT_ID = 'btx-event-group-schema';

    eventGroupCode: string = "";
    eventGroup: EventGroup;
    eventList:BtxPerformanceListItem[];
    eventImage: string | any;
    eventSmallImage: string | any;
    eventMidImage: string | any;
    eventNoSrc!: string;
    groupWideImage: string | any;
    environment = environment;
    config!: ShareButtonsConfig;
    color: string = "#00000";

    adsImageTr = "";
    adsImageEn = "";


    locales: Locale[];
    currentLocale: Locale;

    regions: Region[];
    currentRegion: Region;
    langParam!: string;
    regionParam!: string;
    cQueryParam:string = "";
    deviceInfo: string = "";
    mobileGallery: string[] = [];
    photoItems: string[] = [];

    breadcrumbItems: any;

    calendarOrListStatus: boolean = false;
    constructor(
        @Inject(WINDOW) private window: Window,
        @Inject(APP_BASE_HREF) private baseHref: string,
        private  translateService: TranslateService,
        private clipboard: Clipboard,
        private datePipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private titleService:Title,
        private eventGroupPageStateService: EventGroupPageStateService,
        private eventService : EventService,
        private routerService: RouterService,
        private canonicalService: CanonicalService,
        private seoUrlService: SeoUrlService,
        // private gtmService: GoogleTagManagerService,
        public region: RegionService,
        public i18n: I18nService,
        private seo: SeoService,
        private translate: TranslateService,
        protected localizedDatePipe:LocalizedDatePipe,
        private apiService: ApiService,
        private deviceSelectorService: DeviceDetectorService,
        private gptAdService: GptAdService,
        private structuredDataService: StructuredDataService,
        @Inject(PLATFORM_ID) private platformId: Object) {

        super(translateService, i18n);
        this.eventGroup = this.eventGroupPageStateService.getCurrentEventGroup();
        this.eventList = this.groupEventForList();
        this.eventImage = this.getGroupImage();
        this.eventSmallImage = this.getGroupSmallImage();
        this.eventNoSrc = this.getNoImage();
        this.eventMidImage = this.getGroupMidImage();
        // this.wideImage = this.getWideImage();
        this.eventGroupCode = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.EVENT_GROUP_CODE]
        this.langParam = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.LANGUAGE]
        this.regionParam = this.activatedRoute.snapshot.params[RouteParameter.PARAMS.REGION]
        this.currentLocale = this.i18n.currentLocale;
        this.photoItems = this.getGroupImages();
        this.mobileGallery.push(this.eventImage, ...this.photoItems);
        this.cQueryParam = this.activatedRoute.snapshot.queryParams['c'];
        this.locales = this.i18n.getAvailableLocales();
            this.currentLocale = this.i18n.currentLocale;
            this.regions = this.region.getRegions();
            this.currentRegion = this.region.currentRegion;
            if(isPlatformBrowser(this.platformId) && deviceSelectorService.isDesktop()){
                this.deviceInfo = "desktop";
            }else {
                this.deviceInfo = "mobile";
            }
    }

    ngAfterViewInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        // eventGroup constructor'da senkron set edildiği için koşullu slot
        // div'i ilk change detection turunda DOM'a basılmış oluyor.
        const slotId = this.eventGroup?.id === this.specialEventGroupId
            ? GPT_AD_SLOT_IDS.SIDE_BANNER_330X600
            : GPT_AD_SLOT_IDS.SIDE_BANNER_300X600;
        this.gptAdService.displayAndRefreshAds([slotId]);
    }

    ngOnInit() {
      this.calendarOrListStatus = this.eventGroup.showCalendarFirst;
        console.log(this.photoItems, "this.photoItems");
      this.getAdsImageLink();
        // const gtmTag = {
        //     EventName: this.eventGroup?.name,
        //     eventId: this.eventGroup?.id,
        //     currency: 'TRY',
        //     pixel_id:"374856624739729",
        // };
        this.addFacebookPixelData();
        this.initializeVariables();
        // this.gtmService.addGtmToDom();
        // this.gtmService.pushTag(gtmTag);
        this.translateService
            .stream([
                'shared.labels.titleTickets',
                'shared.labels.officialSite',
                'shared.labels.siteKeywords',
                'sales.labels.events',
            ])
            .pipe(this.takeUntilDestroy())
            .subscribe((translations) => {
                this.titleService.setTitle(
                    (this.eventGroup?.shortName ?? '') +
                        (translations['shared.labels.titleTickets'] ?? ''),
                );
                this.initSeo(translations);
                this.updateBreadcrumbItems(translations);
            });
    }

    updateBreadcrumbItems(translations: Record<string, string>) {
        this.breadcrumbItems = [];
        this.breadcrumbItems.push({label: this.eventGroup.categoryName, href: this.routerService.createCategoryPageUrl(this.eventGroup?.category)});
        this.breadcrumbItems.push({label: this.eventGroup?.subCategoryName, href:this.routerService.createSearchPageUrl(this.eventGroup?.subcategory)});
        if(this.eventGroup.id){
            if(this.eventGroup.eventGroupCustomUrl){
                this.breadcrumbItems.push({label: this.eventGroup?.name , href: this.eventGroup.eventGroupCustomUrl });
            }else{
                const eventsLabel = translations['sales.labels.events'] || 'Etkinlikleri';
                this.breadcrumbItems.push({label: this.eventGroup?.name + ' ' + eventsLabel , href: this.routerService.createEventGroupPageUrl(this.eventGroup.id)});
            }
        }
        //this.breadcrumbItems.push({label: this.eventGroup?.eventName, href:'/etkinlik/' + this.eventGroup?.eventCode + '/' + this.currentRegion.name + '/' + this.currentLocale.lang});
    }



    /** Sayfanın kanonik yol parçaları — slug dahil (bkz. event-group.resolver 301'i). */
    private get seoPagePath(): SeoPagePath {
        return {
            segments: ['etkinlik-grup', this.eventGroupCode],
            slug: this.eventGroup?.keyUrlText,
        };
    }

    initSeo(translations: Record<string, string>) {
        const pagePath = this.seoPagePath;
        const canonicalUrl = this.seoUrlService.buildCanonicalUrl(pagePath, this.langParam);

        this.seo.setTags({
            title:
                this.eventGroup?.name +
                (translations['shared.labels.titleTickets'] ?? '') +
                (translations['shared.labels.officialSite'] ?? ''),
            titleSuffix: '',
            description: this.eventGroup?.description,
            image: ImageUrlManager.toSocialShareImage(this.eventImage),
            keywords:
                this.eventGroup?.name +
                (translations['shared.labels.siteKeywords'] ?? ''),
            // og:url canonical ile aynı olmalı; document.URL SSR'da http üretiyordu.
            url: canonicalUrl,
        });
        this.canonicalService.setCanonicalUrl(canonicalUrl);
        this.canonicalService.setAlternateUrls(this.seoUrlService.buildAlternateUrls(pagePath));
        this.addSchema();
    }

    /**
     * Grubun etkinlik listesini `ItemList` JSON-LD'si olarak yayınlar.
     *
     * `initSeo()` içinden çağrılır (yani `translateService.stream` aboneliğinden):
     * blok SSR HTML'inde hazır olmalı, `ngAfterViewInit` + tarayıcı guard'ı ile
     * üretilen yapısal veri sunucudan gelen HTML'de hiç görünmüyordu.
     * `setJsonLd` id bazlı idempotent olduğu için dil değişiminde tekrar
     * çağrılması bloğu çoğaltmaz, günceller.
     */
    private addSchema(): void {
        this.structuredDataService.setJsonLd(
            EventGroupComponent.SCHEMA_ELEMENT_ID,
            this.createEventGroupSchema(),
        );
    }

    /**
     * Grup sayfası için `ItemList`.
     *
     * Neden grubun kendisi için tek bir `Event` bloğu üretilmiyor: `EventGroup`
     * modelinde mekan, tarih ve sayısal fiyat alanları yok (bkz.
     * event-group.model.ts); üretilebilecek blok zorunlu alanları taşımadığı için
     * Google tarafından elenirdi. Sayfanın gerçek içeriği zaten etkinlik listesi.
     *
     * Alt tip grubun kategori KODUNDAN türetilir (`categoryName` dile göre
     * değişen görünen addır, schema.org tipi değildir).
     */
    private createEventGroupSchema(): Record<string, unknown> | null {
        const itemType = schemaEventType(this.eventGroup?.category);

        return buildEventItemList(
            this.eventGroup?.name || this.eventGroup?.shortName || '',
            (this.eventList ?? []).map((item) => ({
                url: this.seoUrlService.buildCanonicalUrl(
                    { segments: ['etkinlik', item.eventCode], slug: item.keyUrlText },
                    this.langParam,
                ),
                name: item.eventName || item.longName || item.shortName,
                startDate: this.datePipe.transform(
                    item.performanceDate,
                    SCHEMA_DATE_FORMAT,
                    SCHEMA_TIMEZONE,
                ),
                venueName: item.venueName,
                venueCity: item.venueCity,
                price: resolveListItemPrice(item.minPrice, item.priceInfo),
                eventType: itemType,
            })),
        );
    }


    isAvifImage(src?: string | null): boolean {
        if (!src) {
          return false;
        }
        return src.toLowerCase().endsWith('.avif');
      }

    addFacebookPixelData(){


        (this.window as any)["digitalData"] = [{
            "page": {
                "pageInfo": {
                    "campaign":this.cQueryParam,
                	"destinationURL": this.window.location.href,
                	"domain": this.apiService.getDomain(),
                    "geoRegion":this.currentRegion.name,
                    "language": this.currentLocale.lang,
                    "pageChannel":"EDP",
                    "pageName":"EDP: Classic: Event",
                    "pageType": "EDP: Classic: Event",
                    "referringURL":"",
                    "sysEnv":this.deviceInfo,
                },
                "attributes": {
                	//'artistName':this.eventGroup?.eventName,
                    //"city":this.eventGroup?.venueCity,
                    //"country":this.eventGroup?.venueCountry,
					//'eventDate':this.localizedDatePipe.transform(this.eventGroup?.firstPerformanceDate, 'yyyy-MM-dd HH:mm:ss'),
					//'eventDateEnd': this.localizedDatePipe.transform(this.eventGroup?.lastPerformanceDate, 'yyyy-MM-dd HH:mm:ss'),
					//'eventDateStart':this.localizedDatePipe.transform(this.eventGroup?.firstPerformanceDate, 'yyyy-MM-dd HH:mm:ss'),
        		    //'eventID': this.eventGroup?.eventCode,
        		    //'eventName':this.eventGroup?.eventName,
        		    //'eventTime':this.localizedDatePipe.transform(this.eventGroup?.firstPerformanceDate, 'HH:mm'),
                    //"promoterId":this.eventGroup?.promoterCode,
                    //"venueId":this.eventGroup?.venueId,
                    //"venueName":this.eventGroup?.venueName,
                },
                "category": {
					'organization':'TM_Turkey',
					//'primaryCategory':this.eventGroup?.eventCategory,
					'primaryCategoryID':"",
					//'subCategory1':this.eventGroup?.subCategory,
					'subCategory1Id':""

                }
            }
        }];

        // (this.window as any)["dataLayer"].pop({ page: null });
        // (this.window as any)["dataLayer"].push({
        //     "page": {
        //         "pageInfo": {
        //             "campaign":this.cQueryParam,
        //         	"destinationURL": this.window.location.href,
        //         	"domain": this.apiService.getDomain(),
        //             "geoRegion":this.currentRegion.name,
        //             "language": this.currentLocale.lang,
        //             "pageChannel":"EDP",
        //             "pageName":"EDP: Classic: Event",
        //             "pageType": "EDP: Classic: Event",
        //             "referringURL":"",
        //             "sysEnv":this.deviceInfo,
        //         },
        //         "attributes": {
        //         	//'artistName':this.eventGroup?.eventName,
        //             //"city":this.eventGroup?.venueCity,
        //             //"country":this.eventGroup?.venueCountry,
		// 			//'eventDate':this.localizedDatePipe.transform(this.eventGroup?.firstPerformanceDate, 'yyyy-MM-dd HH:mm:ss'),
		// 			//'eventDateEnd': this.localizedDatePipe.transform(this.eventGroup?.lastPerformanceDate, 'yyyy-MM-dd HH:mm:ss'),
		// 			//'eventDateStart':this.localizedDatePipe.transform(this.eventGroup?.firstPerformanceDate, 'yyyy-MM-dd HH:mm:ss'),
        // 		    //'eventID': this.eventGroup?.eventCode,
        // 		    //'eventName':this.eventGroup?.eventName,
        // 		    //'eventTime':this.localizedDatePipe.transform(this.eventGroup?.firstPerformanceDate, 'HH:mm'),
        //             //"promoterId":this.eventGroup?.promoterCode,
        //             //"venueId":this.eventGroup?.venueId,
        //             //"venueName":this.eventGroup?.venueName,
        //         },
        //         "category": {
		// 			'organization':'TM_Turkey',
		// 			//'primaryCategory':this.eventGroup?.eventCategory,
		// 			'primaryCategoryID':"",
		// 			//'subCategory1':this.eventGroup?.subCategory,
		// 			'subCategory1Id':""

        //         }
        //     }
        // });
    }

    initializeVariables() {
        this.config = {
            url: this.window.location.href,
            description: this.eventGroup.name,
            title: this.eventGroup.name,
            image: this.getGroupImage()
        };
    }

    getGroupImage(): string {
        return ImageUrlManager.createGroupImage(this.eventGroup.groupImage);
    }

    getGroupSmallImage(): string {
        return ImageUrlManager.createGroupSmallImage(this.eventGroup.groupImage);
    }

    getGroupMidImage(): string {
        return ImageUrlManager.createGroupMidImage(this.eventGroup.groupImage);
    }

    getNoImage(): string {
        return ImageUrlManager.createEventImage("noimage.gif");
    }

    getWideImage(): string {
        return ImageUrlManager.createGroupWideImage(this.eventGroup.groupWideImage);
    }

    onLoadImage(imageRef: HTMLImageElement) {
        if (imageRef) {
            const a = ImageProcessing.getAverageRGB(imageRef);
            this.color = a.hex();
        }
    }

    private getGroupImages(): string[] {
        const images = this.eventGroup.imageList ?? [];
        return images.map((url: string) => ImageUrlManager.create(url, environment.eventPhotosBasePath));
    }

    // getVenuePageUrl(): string {
    //     return this.routerService.createVenuePageUrl(this.eventGroup?.venueId);
    // }

  getAdsImageLink() {
    this.adsImageTr = ImageUrlManager.createStaticImage('right-col-image-2024.png');
    this.adsImageEn = ImageUrlManager.createStaticImage('right-col-image-2024-en.png');
  }

  groupEventForList():BtxPerformanceListItem[] {
      const eventMap:Map<string, BtxPerformanceListItem> = new Map<string, BtxPerformanceListItem>();

    const priorityList = ['s01_onsale', 's03_soon', 's05_postponed', 's02_soldout', 's12_checkbacklater',
      's04_canceled','s00_closed','s06_boxoffice','s16_rescheduled','s17_venue_changed','s14_other_channels','s13_old_over',];

    this.eventGroup.events.forEach(event => {
        if (!eventMap.has(event.eventCode)) {
          eventMap.set(event.eventCode,event);
          eventMap.get(event.eventCode)!.firstPerformanceDate = event.performanceDate;
          eventMap.get(event.eventCode)!.lastPerformanceDate = event.performanceDate;
        } else {
          const firstEvent = eventMap.get(event.eventCode);
          if (firstEvent && firstEvent.firstPerformanceDate && firstEvent.firstPerformanceDate > event.performanceDate) {
            eventMap.get(event.eventCode)!.firstPerformanceDate = event.performanceDate;
          }
          if (firstEvent && firstEvent.lastPerformanceDate && firstEvent.lastPerformanceDate < event.performanceDate) {
            eventMap.get(event.eventCode)!.lastPerformanceDate = event.performanceDate;
          }
          if (priorityList.indexOf(firstEvent!.status) > priorityList.indexOf(event.status)) {
            eventMap.get(event.eventCode)!.status = event.status;
          }
        }
      })
    return [...eventMap.values()];
  }

  // performanceList: BtxPerformanceListItem[] = [];
  // calendarmethod() {
  //   this.calendarOrListStatus = true;
  //   this.eventService
  //     .getPerformancesByEventCode(this.eventCode)
  //     .subscribe((performances) => {
  //       if (performances && performances.length > 0) {
  //         performances.forEach((item: any) => {
  //           item.active = item.status == 's01_onsale';
  //           item.performanceDate = this.localizedDate(item.performanceDate);

  //           item.firstPerformanceDate = item.performanceDate;
  //           delete item.performanceDate;

  //           item.eventName = item.venueName;
  //           delete item.venueName;
  //         });
  //       }
  //       this.performanceList = performances;
  //       console.log(performances, 'performances');
  //     });
  // }

  // localizedDate(
  //   value: any,
  //   format: string = 'mediumDate',
  //   useClientTimezone: boolean = false
  // ): any {
  //   let defaultTimezone: string = '+0300';
  //   if (value) {
  //     const result = this.datePipe.transform(
  //       value,
  //       format,
  //       useClientTimezone ? undefined : defaultTimezone
  //     );
  //     const date = new Date(result!);
  //     return date;
  //   }
  // }
}
